import module from './module.js'

import './components/exportar/component.js'
import './components/launcher/component.js'
import './routes/nominas-fondoreserva.js'
import './services/FondoReserva.js'
import './services/FondoReserva/Nominas.js'
import './services/FondoReserva/Nominas/Nomina.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/fondoreserva/index.js